import React from "react";
import CreateAccountWidget from "../CreateAccountWidget/CreateAccountWidget";
import HeaderDownload from "../HeaderDownload/HeaderDownload";
import ChnLangPref from "../Profile/ChnLangPref";
import style from "./style.module.css";

const PreLoginView = (props) => {
  return (
    <div className={style["margin-top-negative"]}>
      {props?.isPwaOpen ? "" : <HeaderDownload />}
      {/* <ChnLangPref /> */}
      <CreateAccountWidget setShow={props.setShow} />
    </div>
  );
};
export default PreLoginView;
